<template>
    <!-- currentColor + the icon-primary role; the drawn #0069FF was that
         token's light value, so light is unchanged and dark now flips. -->
    <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="text-(--icon-primary)"
    >
        <path
            d="M4.5 8.15793L8 5.00003M8 5.00003L11.5 8.15793M8 5.00003V12.4"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
